package com.eladfinish.bible.contest.di

import com.eladfinish.bible.contest.repository.analytics.FirebaseAnalyticsRepository
import com.eladfinish.bible.contest.repository.analytics.FirebaseAnalyticsRepositoryImpl
import com.eladfinish.bible.contest.repository.remoteConfig.RemoteConfigRepository
import com.eladfinish.bible.contest.repository.remoteConfig.RemoteConfigRepositoryImpl
import com.eladfinish.bible.contest.screens.americanQuestions.AmericanQuestionsRepository
import com.eladfinish.bible.contest.screens.americanQuestions.AmericanQuestionsRepositoryImpl
import org.koin.core.module.dsl.factoryOf
import org.koin.dsl.bind
import org.koin.dsl.module

val repositoryModule = module {
    factoryOf(::AmericanQuestionsRepositoryImpl) bind AmericanQuestionsRepository::class

    factoryOf(::RemoteConfigRepositoryImpl) bind RemoteConfigRepository::class

    factoryOf(::FirebaseAnalyticsRepositoryImpl) bind FirebaseAnalyticsRepository::class
}
